/* eslint-disable import/no-unused-modules -- consumed by the FlowCanvas layout engine (Task 3) */
/** Geometry mirrored 1:1 from the legacy CSS canvas
 *  (components/ActionGroup/Branches/style.tsx, Sidebar/style.tsx).
 *  Values are tuned during the visual-parity QA pass (Task 10). */
export const CARD_WIDTH = 350;
export const COLUMN_MIN_WIDTH = 400;
export const COLUMN_GAP = 10;
export const CONNECTOR_ZONE = 60;
export const CARD_VGAP = 10;
export const FAN_EDGE_GAP = 10;
/** Legacy Sidebar StyledContainer margin-bottom between When and Then blocks. */
export const WHEN_THEN_SECTION_GAP = 40;
/** Legacy NestedBranchesFan: StyledBranchRow margin-top + padding-top. */
export const NESTED_FAN_ROW_LEAD = 10 + CONNECTOR_ZONE + 10;
export const LOOP_HEADER_HEIGHT = 48;
/** Height reserved for a COLLAPSED loop card. The header's two-line content
 *  (Looping label + "Repeat for each in" name) plus its 10px top/bottom
 *  padding is taller than LOOP_HEADER_HEIGHT; an EXPANDED loop hides that
 *  overflow in the LOOP_PADDING gap above its first child, but a collapsed
 *  card has no gap below, so it must reserve the full header height or its
 *  bottom padding is clipped by the border. */
export const COLLAPSED_LOOP_HEIGHT = 60;
export const LOOP_PADDING = 25;
export const EDGE_CORNER_RADIUS = 8;
/** Measured height of NodeSectionLabel (Title xl + Paragraph + padding). */
export const SECTION_LABEL_HEIGHT = 52;
/** Below this handle gap an L-corner cannot render cleanly — spine only. */
export const MIN_STEP_CORNER_SPAN = 24;
/** Legacy StyledLine sits 13px left of the 350px card (`left: -13px`). */
export const SPINE_OFFSET = 13;

/* Zoom limits mirror the legacy canvas.store (25%-200%), expressed as React
 * Flow scale factors. */
export const FLOW_MIN_ZOOM = 0.25;
export const FLOW_MAX_ZOOM = 2;
